// Angular
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// RxJS
import { map, of, switchMap } from 'rxjs';

// App services
import { AppBootstrapService, TokenRefreshService } from '@app/core/services';


export const bootstrapGuard: CanActivateFn = () => {
  const router = inject(Router);
  const bootstrap = inject(AppBootstrapService);
  const tokenRefresh = inject(TokenRefreshService);

  return tokenRefresh.ensureAccessToken().pipe(
    switchMap(hasSession => {
      if (!hasSession) {
        return of(router.createUrlTree(['/auth/identify']));
      }

      return bootstrap.ensureLoaded().pipe(
        map(success => success || router.createUrlTree(['/auth/identify'])),
      );
    }),
  );
};
